module.exports = "<checklist-section section-title=\"$ctrl.title\" description=\"$ctrl.description\"></checklist-section>";